import type { components } from '@/lib/api-types-expenses-parity';

/** The internal class (#915 C4): A1, A2, P, PG, PD, or none («Nessuna»). */
export type InternalClass = NonNullable<components['schemas']['InternalClass']>;
export const INTERNAL_CLASSES: readonly InternalClass[] = ['A1', 'A2', 'P', 'PG', 'PD'];

/** The list's query value for «Nessuna» (`class=none`). */
export const NO_CLASS = 'none';
export type ClassFilterValue = InternalClass | typeof NO_CLASS;
export const CLASS_FILTER_VALUES: readonly ClassFilterValue[] = [NO_CLASS, ...INTERNAL_CLASSES];

export function isClassFilterValue(value: string): value is ClassFilterValue {
  return (CLASS_FILTER_VALUES as readonly string[]).includes(value);
}

/**
 * The class a view carries, or `undefined` when the view has none: the server sends it only to
 * Gestione and the note's approvers, so its absence is what hides the control.
 */
export function classOf(view: object): InternalClass | null | undefined {
  if (!('internalClass' in view)) return undefined;
  const value = view.internalClass;
  return INTERNAL_CLASSES.find((code) => code === value) ?? null;
}

/** Who sees and sets the class: Gestione and the approvers (the Director, 1 November). */
export const EXPENSES_CLASSIFIERS: readonly string[] = [
  'expenses:expense:manage',
  'expenses:report:approve',
];
